import { Observable } from 'rxjs';
import { ListadoCentroCostosResponseDTO } from 'src/app/data/dto/CentroCostosDTO';

export abstract class CentroCostosRepository {
    abstract listaCentroCostos(): Observable <ListadoCentroCostosResponseDTO>;
}
